<template>
	<el-dialog title="提问老师" center :visible="show" @close="close">
		<div class="header_center p_flex p_f_a ">
			<span class="p_m_l_20 type_size_18">选择老师</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20">
				<el-select v-model="postData.teacher_id" placeholder="请选择" @change="getTeacherList">
					<el-option v-for="(item,index) in teacherList" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
		</div>
		<div class=" p_flex p_f_a p_m_t_30 ">
			<div class="p_f_1 ">
				<el-input type="textarea"  :autosize="{ minRows: 4}" v-model="postData.title" placeholder="请输入内容"></el-input>
			</div>
		</div>
		<div class="p_flex p_f_c p_m_t_30"><el-button @click="submit()" type="success">确认</el-button></div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		show: null
	},
	data() {
		return {
			teacherList: [ ],
			postData: { teacher_id:null, title:null, type: 2},
		};
	},
	mounted() {
		this.getTeacherList()
	},
	methods: {

		getTeacherList(){
			this.$request.ajax(this).post('api_student/put_question_choice_teacher').then(res=>{
				this.teacherList = res.data
			})
		},

		close() {
			this.$emit('closes', false);
		},

		submit() {

			var postData = this.postData
			if( !postData.teacher_id ) return this.$message.info('请选择老师')
			if( !postData.title) return this.$message.info('请输入提问内容')
			postData.student_content = this.postData.title
			this.$request.ajax(this).post('api_student/put_question_teacher',postData).then(res=>{
				this.postData.title = null
				this.$message.success('提交成功')
				this.close()
			})

		},

	}
};
</script>

<style lang="scss" scoped>
.header_center {
	height: 65px;
	background: #f5f5f5;
	border-radius: 10px;
}
>>> .el-input__inner {
	border: none;
	background: #f5f5f5;
	font-size: 18px;
}
>>> .el-select {
	width: 100%;
}
>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
>>>.el-select .el-input .el-select__caret{
	font-size: 18px;
	color: #000000;
}
>>>.el-textarea__inner{
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 20px;
}
>>> textarea::-webkit-input-placeholder {
	font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/home/commponents/popUp.vue